import { Stack, Typography } from '@mui/material';
import { AccountState, type Account } from '@repo/api-gw-sdk';
import semver from 'semver';

import { isAccountRoleMajorMinorVersionOld } from '@/utils/roles';

export const EonRoleVersion = ({ account }: { account: Account }) => {
  if (account.state === AccountState.ACCOUNT_STATE_INSUFFICIENT_PERMISSIONS) {
    return null;
  }

  const showWarning = isAccountRoleMajorMinorVersionOld(account);

  return (
    <Stack direction='row' alignItems='center' gap='12px'>
      <Typography className={'inline-block'}>
        {'installedVersion' in account && semver.valid(account.installedVersion)
          ? account.installedVersion
          : '1.0.0'}
      </Typography>
      {showWarning && (
        <Typography
          variant='subtitle2'
          padding='4px 8px'
          border='1px solid #FE5C00'
          borderRadius='4px'
          color='#FE5C00 !important'
          noWrap
        >
          Update available
        </Typography>
      )}
    </Stack>
  );
};
